import React, { forwardRef, type Ref } from 'react'

import type { ReactButtonProps } from '../types'

export const UnstyledButton = forwardRef(function _UnstyledButton(
  { type = 'button', ...props }: ReactButtonProps,
  ref: Ref<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      css={{
        WebkitAppearance: 'none',
        WebkitTapHighlightColor: 'transparent',
        background: 'none',
        border: '0',
        color: 'unset',
        font: 'inherit',
        padding: '0',
        textAlign: 'unset',
      }}
      // NOTE(eric.lovett): `type` has the correct set of possible values, but
      // the ESLint rule isn't sophisticated enough to figure that out.
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...props}
    />
  )
})
